/* eslint-disable */
import axios from "axios";

export const BASE_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:8000"
    : "https://api.oddular.com";

export const PAGINATION_OBJECT = {
  count: 0,
  page_size: 0,
  last_page: 0,
  page_num: 0,
  num_pages: 0,
  next: null,
  previous: null,
};

const _axios = axios.create({});

const api = context => {
  _axios.defaults.headers.common.authorization = `Bearer ${context.rootState.auth.access}`;
  return _axios;
};

export default api;
